import React from 'react';
import { Link } from 'react-router-dom';
import './DestinationsGrid.css';

function DestinationsGrid({ searchQuery, selectedCategory }) {
  const destinations = [
    {
      id: 1,
      name: 'Arusha National Park',
      image: '/assets/imgs/destination/arusha-national-park.jpg',
      description: 'A diverse ecosystem with lush forests, wildlife, and stunning landscapes.',
      category: 'national-park',
      highlights: [
        'Diverse wildlife including giraffes and colobus monkeys',
        'Stunning Mount Meru backdrop',
        'Varied landscapes from rainforest to alpine desert'
      ],
      bestTime: 'Year-round',
      duration: '1-2 days'
    },
    {
      id: 2,
      name: 'Lake Manyara National Park',
      image: '/assets/imgs/destination/lake-manyara.jpg',
      description: 'Famous for its tree-climbing lions and diverse birdlife.',
      category: 'national-park',
      highlights: [
        'Unique tree-climbing lions',
        'Massive flamingo populations',
        'Scenic lake views and diverse ecosystems'
      ],
      bestTime: 'Year-round',
      duration: '1 day'
    },
    {
      id: 3,
      name: 'Ndutu Plains',
      image: '/assets/imgs/destination/ndutu.jpg',
      description: 'Witness the great wildebeest migration and abundant wildlife.',
      category: 'national-park',
      highlights: [
        'Wildebeest migration hotspot',
        'Vast open plains',
        'Excellent predator viewing'
      ],
      bestTime: 'December - March',
      duration: '2-3 days'
    },
    {
      id: 4,
      name: 'Ngorongoro Crater',
      image: '/assets/imgs/destination/ngorongoro1.jpg',
      description: 'A UNESCO World Heritage site with incredible wildlife density.',
      category: 'national-park',
      highlights: [
        'World\'s largest intact volcanic caldera',
        'High concentration of wildlife',
        'Home to endangered black rhinos'
      ],
      bestTime: 'Year-round',
      duration: '1-2 days'
    },
    {
      id: 5,
      name: 'Serengeti National Park',
      image: '/assets/imgs/destination/serengeti1.jpg',
      description: 'Iconic safari destination with endless plains and abundant wildlife.',
      category: 'national-park',
      highlights: [
        'Endless savannah landscapes',
        'Home to the great migration',
        'Incredible predator populations'
      ],
      bestTime: 'Year-round',
      duration: '3-7 days'
    },
    {
      id: 6,
      name: 'Tarangire National Park',
      image: '/assets/imgs/destination/tarangire1.jpg',
      description: 'Known for its large elephant herds and baobab trees.',
      category: 'national-park',
      highlights: [
        'Massive elephant herds',
        'Iconic baobab trees',
        'Seasonal wildlife migrations'
      ],
      bestTime: 'June - October',
      duration: '1-2 days'
    },
    {
      id: 7,
      name: 'Mount Kilimanjaro',
      image: '/assets/imgs/destination/Mount-Kilimanjaro.jpg',
      description: 'Africa\'s highest peak and one of the world\'s most iconic mountains.',
      category: 'mountain',
      highlights: [
        'Africa\'s highest peak (5,895m)',
        'Multiple climbing routes',
        'Stunning sunrise views from the summit'
      ],
      bestTime: 'January - March, June - October',
      duration: '5-9 days'
    },
    {
      id: 8,
      name: 'Zanzibar Island',
      image: '/assets/imgs/destination/zanzibar.jpeg',
      description: 'Tropical paradise with white sandy beaches and rich cultural heritage.',
      category: 'beach',
      highlights: [
        'Pristine white sandy beaches',
        'Rich Swahili cultural heritage',
        'Historic Stone Town UNESCO site'
      ],
      bestTime: 'Year-round',
      duration: '3-7 days'
    },
    {
      id: 9,
      name: 'Ruaha National Park',
      image: '/assets/imgs/destination/ruaha.webp',
      description: 'Tanzania\'s largest national park with diverse wildlife and stunning landscapes.',
      category: 'national-park',
      highlights: [
        'Largest national park in Tanzania',
        'High concentration of elephants',
        'Remote and unspoiled wilderness'
      ],
      bestTime: 'June - October',
      duration: '3-5 days'
    },
    {
      id: 10,
      name: 'Nyerere National Park',
      image: '/assets/imgs/destination/nyerere.jpg',
      description: 'Formerly Selous Game Reserve, one of Africa\'s largest protected areas.',
      category: 'national-park',
      highlights: [
        'One of Africa\'s largest game reserves',
        'Excellent walking safari opportunities',
        'Diverse ecosystems and wildlife'
      ],
      bestTime: 'June - October',
      duration: '4-6 days'
    },
    {
      id: 11,
      name: 'Mikumi National Park',
      image: '/assets/imgs/destination/mikumi.jpg',
      description: 'Accessible park with abundant wildlife and beautiful savannah landscapes.',
      category: 'national-park',
      highlights: [
        'Easy accessibility from Dar es Salaam',
        'Large herds of elephants and buffalo',
        'Open grasslands perfect for game viewing'
      ],
      bestTime: 'Year-round',
      duration: '2-3 days'
    },
    {
      id: 12,
      name: 'Mount Meru',
      image: '/assets/imgs/destination/mount-meru.webp',
      description: 'Tanzania\'s second highest peak offering challenging climbs and stunning views.',
      category: 'mountain',
      highlights: [
        'Tanzania\'s second highest peak (4,566m)',
        'Less crowded than Kilimanjaro',
        'Stunning views of Kilimanjaro'
      ],
      bestTime: 'June - October, December - February',
      duration: '3-4 days'
    },
    {
      id: 13,
      name: 'Mafia Island',
      image: '/assets/imgs/destination/Mafia_Island_Whale_Shark_04.jpg',
      description: 'Pristine island paradise with world-class diving and marine life.',
      category: 'beach',
      highlights: [
        'World-class diving and snorkeling',
        'Marine protected area',
        'Pristine beaches and clear waters'
      ],
      bestTime: 'Year-round',
      duration: '3-5 days'
    },
    {
      id: 14,
      name: 'Pemba Island',
      image: '/assets/imgs/destination/pemba.jpeg',
      description: 'The "Green Island" known for its lush vegetation and excellent diving.',
      category: 'beach',
      highlights: [
        'Excellent diving and snorkeling',
        'Lush green landscapes',
        'Authentic Swahili culture'
      ],
      bestTime: 'Year-round',
      duration: '3-5 days'
    },
    {
      id: 15,
      name: 'Lake Victoria',
      image: '/assets/imgs/destination/Lake-Victoria.jpg',
      description: 'Africa\'s largest lake offering fishing, bird watching, and cultural experiences.',
      category: 'national-park',
      highlights: [
        'Africa\'s largest lake',
        'Excellent fishing opportunities',
        'Rich birdlife and cultural sites'
      ],
      bestTime: 'Year-round',
      duration: '2-3 days'
    },
    {
      id: 16,
      name: 'Olduvai Gorge',
      image: '/assets/imgs/destination/olduvai_gorge.jpg',
      description: 'The "Cradle of Mankind" with significant archaeological discoveries.',
      category: 'national-park',
      highlights: [
        'Important archaeological site',
        'Museum with ancient fossils',
        'Birthplace of humanity'
      ],
      bestTime: 'Year-round',
      duration: 'Half day'
    },
    {
      id: 17,
      name: 'Gombe Stream National Park',
      image: '/assets/imgs/destination/Gombe.jpeg',
      description: 'Famous for chimpanzee tracking and Jane Goodall\'s research.',
      category: 'national-park',
      highlights: [
        'Chimpanzee tracking opportunities',
        'Jane Goodall\'s research site',
        'Dense forest and waterfalls'
      ],
      bestTime: 'May - October',
      duration: '2-3 days'
    },
    {
      id: 18,
      name: 'Mahale Mountains National Park',
      image: '/assets/imgs/destination/Gombe.jpeg',
      description: 'Remote park on Lake Tanganyika known for chimpanzee populations.',
      category: 'national-park',
      highlights: [
        'Large chimpanzee populations',
        'Stunning Lake Tanganyika views',
        'Remote and pristine wilderness'
      ],
      bestTime: 'May - October',
      duration: '4-6 days'
    },
    {
      id: 19,
      name: 'Katavi National Park',
      image: '/assets/imgs/destination/Katavi-National-Parkdd.jpg',
      description: 'Remote park with large hippo and crocodile populations.',
      category: 'national-park',
      highlights: [
        'Large hippo populations',
        'Remote and untouched wilderness',
        'Excellent dry season game viewing'
      ],
      bestTime: 'June - October',
      duration: '3-5 days'
    },
    {
      id: 20,
      name: 'Udzungwa Mountains',
      image: '/assets/imgs/destination/udzungwa-national-park.jpeg',
      description: 'Biodiversity hotspot with endemic species and beautiful waterfalls.',
      category: 'mountain',
      highlights: [
        'Rich biodiversity and endemic species',
        'Beautiful waterfalls and hiking trails',
        'Primate watching opportunities'
      ],
      bestTime: 'June - October',
      duration: '2-3 days'
    }
  ];

  // Filter destinations based on search query and category
  const filteredDestinations = destinations.filter((destination) => {
    const matchesSearch = destination.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
                         destination.description.toLowerCase().includes(searchQuery.toLowerCase());
    const matchesCategory = selectedCategory === 'all' || destination.category === selectedCategory;
    return matchesSearch && matchesCategory;
  });

  return (
    <div className="destinations-grid-container">
      <div className="destinations-grid-header">
        <h2 className="destinations-grid-title">
          {filteredDestinations.length} {filteredDestinations.length === 1 ? 'Destination' : 'Destinations'} Found
        </h2>
      </div>

      {filteredDestinations.length > 0 ? (
        <div className="destinations-grid">
          {filteredDestinations.map((destination) => (
            <div key={destination.id} className="destination-card-full">
              <Link 
                to={`/destinations/${destination.name.toLowerCase().replace(/\s+/g, '-')}`}
                className="destination-card-link"
              >
                <div className="destination-card-image-wrapper">
                  <img 
                    src={destination.image} 
                    alt={destination.name}
                    className="destination-card-image"
                  />
                  <div className="destination-card-overlay">
                    <span className="destination-card-category">
                      {destination.category === 'national-park' ? 'National Park' : 
                       destination.category === 'beach' ? 'Beach' : 'Mountain'}
                    </span>
                  </div>
                </div>
                
                <div className="destination-card-content">
                  <h3 className="destination-card-name">{destination.name}</h3>
                  <p className="destination-card-description">{destination.description}</p>
                  
                  <div className="destination-card-info">
                    <div className="destination-info-item">
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <circle cx="12" cy="12" r="10"/>
                        <polyline points="12 6 12 12 16 14"/>
                      </svg>
                      <span>{destination.duration}</span>
                    </div>
                    <div className="destination-info-item">
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <rect x="3" y="4" width="18" height="18" rx="2" ry="2"/>
                        <line x1="16" y1="2" x2="16" y2="6"/>
                        <line x1="8" y1="2" x2="8" y2="6"/>
                        <line x1="3" y1="10" x2="21" y2="10"/>
                      </svg>
                      <span>{destination.bestTime}</span>
                    </div>
                  </div>

                  <div className="destination-card-highlights">
                    <ul>
                      {destination.highlights.slice(0, 3).map((highlight, index) => (
                        <li key={index}>{highlight}</li>
                      ))}
                    </ul>
                  </div>

                  <div className="destination-card-footer">
                    <span className="destination-card-cta">
                      Explore More
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M5 12h14M12 5l7 7-7 7"/>
                      </svg>
                    </span>
                  </div>
                </div>
              </Link>
            </div>
          ))}
        </div>
      ) : (
        <div className="destinations-empty">
          <p>No destinations found matching your search.</p>
        </div>
      )}
    </div>
  );
}

export default DestinationsGrid;

